<script setup lang="ts">
    import DataTableActions from '@/components/datatable/DataTableActions.vue';
    import { CompanyOnboardingFile, OnboardingStep } from '@/types';
    import { ChevronDown } from 'lucide-vue-next';
    import {
        DropdownMenu,
        DropdownMenuContent,
        DropdownMenuItem,
        DropdownMenuTrigger,
    } from '@/components/ui/dropdown-menu';
    import { Button } from '@/components/ui/button';
    import { useI18n } from 'vue-i18n';

    const { t } = useI18n();

    const props = defineProps<{
        companyOnboardingStep: OnboardingStep;
        files?: CompanyOnboardingFile[];
    }>();

    const downloadFile = (file: CompanyOnboardingFile) => {
        window.open(
            route('v2.onboarding.files.download', {
                companyOnboardingStep: props.companyOnboardingStep.id,
                storageFile: file.id,
            }),
            '_blank',
        );
    };
</script>

<template>
    <DataTableActions
        v-if="!!files?.length"
        :data="companyOnboardingStep"
    >
        <DropdownMenu>
            <DropdownMenuTrigger as-child>
                <Button
                    variant="continue"
                    size="xs"
                >
                    {{ t('onboarding.download.title', { count: files.length }) }}
                    <ChevronDown />
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent>
                <DropdownMenuItem
                    v-for="file in files"
                    @click="downloadFile(file)"
                >
                    {{ file.original_filename }}
                </DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenu>
    </DataTableActions>
</template>
